
const transactionTypes = [
    {name: 'directPartner', class: 'bg-white'},
    {name: 'spillOverAbove', class: 'bg-light-blue'},
    {name: 'spillOverBelow', class: 'bg-yellow'},
    {name: 'freeFlow', class: 'bg-green-500'}
]

export default transactionTypes;